import React from "react";
import {
  Box,
  Typography,
  Stepper as MuiStepper,
  StepContent,
  Step,
  StepLabel,
  styled,
} from "@mui/material";
import { StepIconProps } from "@mui/material/StepIcon";

export interface StepperProps {
  steps: {
    value: number;
    label: string;
    heading: string;
    description: string;
  }[];
}
const StyledLabel = styled(StepLabel, {
  shouldForwardProp: (prop: any) => prop !== "active",
})<{ active?: boolean | undefined }>(({ active }) => ({
  "& .MuiTypography-root": {
    fontSize: active ? "36px" : "24px",
  },
}));

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ ownerState }) => ({
  backgroundColor: "#B1D238",
  zIndex: 1,
  color: "#fff",
  width: 19,
  height: 19,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    width: 50,
    height: 50,
    backgroundImage: "#B1D238",
    backgroundColor: "#B1D238",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#B1D238",
    backgroundImage: "#B1D238",
  }),
}));
const Stepper = ({ steps }: StepperProps) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const ColorlibStepIcon = (props: StepIconProps) => {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
      1: <i className="far fa-calendar" />,
      2: <i className="far fa-calendar" />,
      3: <i className="far fa-calendar" />,
      4: <i className="far fa-calendar" />,
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {active && icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  };

  return (
    <Box>
      <MuiStepper activeStep={activeStep} orientation="vertical">
        {steps &&
          steps.map((step, index) => {
            const stepProps: { active?: boolean } = {
              active: activeStep === index,
            };

            return (
              <Step
                key={step.value}
                onClick={() => setActiveStep(step.value)}
                {...stepProps}
              >
                <StyledLabel
                  active={stepProps.active}
                  StepIconComponent={ColorlibStepIcon}
                  onClick={() => setActiveStep(step.value)}
                >
                  <Typography variant="h1" color="primary">
                    {step.label}
                  </Typography>
                </StyledLabel>
                <StepContent>
                  <Typography fontWeight={700}>{step.heading}</Typography>
                  <Typography>{step.description}</Typography>
                </StepContent>
              </Step>
            );
          })}
      </MuiStepper>
    </Box>
  );
};
export default Stepper;
